import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';

import CarouselImage from "./components/CarouselImage";
import CarouselNavButton from "./components/CarouselNavButton";

ProductImageCarousel.propTypes = {
    images: PropTypes.arrayOf(PropTypes.string),
    selected: PropTypes.number,
    onSelect: PropTypes.func
};

function ProductImageCarousel({images = [], selected = 0, onSelect = () => {}}) {
    const rowRef = useRef(null);
    const itemRefs = useRef([]);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        itemRefs.current[selected]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest',
        });
    }, [selected]);

    // the arrows follow what actually overflows the row, not a thumbnail count tied to today's sizes
    useEffect(() => {
        const row = rowRef.current;

        if (!row) {
            return;
        }

        const measure = () => setIsOverflowing(row.scrollWidth > row.clientWidth);

        measure();

        if ('undefined' === typeof ResizeObserver) {
            return;
        }

        const observer = new ResizeObserver(measure);
        observer.observe(row);

        return () => observer.disconnect();
    }, [images.length]);

    if (!images || images.length === 0) {
        return null;
    }

    return (
        <div style={{position: 'relative', userSelect: 'none'}}>
            <div
                ref={rowRef}
                style={{
                    display: 'flex',
                    gap: '8px',
                    marginTop: '8px',
                    width: '100%',
                    overflow: 'hidden',
                }}
            >
                {images.map((image, index) => (
                    <CarouselImage
                        key={image}
                        ref={(el) => itemRefs.current[index] = el}
                        image={image}
                        selected={index === selected}
                        onClick={() => onSelect(index)}
                    />
                ))}
            </div>

            {(selected !== 0) && isOverflowing && (
                <CarouselNavButton
                    variant={'left'}
                    onClick={() => onSelect(Math.max(selected - 1, 0))}
                />
            )}

            {(selected + 1 !== images.length) && isOverflowing && (
                <CarouselNavButton
                    variant={'right'}
                    onClick={() => onSelect(Math.min(selected + 1, images.length - 1))}
                />
            )}
        </div>
    );
}

export default ProductImageCarousel;
